import axios from "axios"

const REST_BASE_URL = import.meta.env.VITE_REST_API as string || 'https://task.teclaverde.com/api/v1/'

export const axiosInstance = axios.create({
    baseURL: REST_BASE_URL,
});
